module.exports = __webpack_public_path__ + "static/media/instagram.dafaf94f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/instagram.png
// module id = 1146
// module chunks = 0